import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap"; // Importing React Bootstrap components
import ProgressBar from "react-bootstrap/ProgressBar";
import Pagination from "react-bootstrap/Pagination";
import Editbtn from "../images/circum_edit.svg";
import viewbtn from "../images/iconoir_eye-solid.svg";
import commentbtn from "../images/lets-icons_comment-light.svg";
import { baseURL } from "../config";

const SubData = () => {
  const [posts, setPosts] = useState({ subgoals: [] });
  const [editedSubGoal, setEditedSubGoal] = useState(null);
  const [selectedSubGoal, setSelectedSubGoal] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [viewSubGoal, setViewSubGoal] = useState(null);

  useEffect(() => {
    const fetchPostList = async () => {
      try {
        const { data } = await axios(`${baseURL}/getsubgoals`);
        if (Array.isArray(data.subgoals)) {
          setPosts({ subgoals: data.subgoals });
        } else {
          console.error("Data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPostList();
  }, []);

  // Get current posts
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.subgoals.slice(indexOfFirstPost, indexOfLastPost);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Define the getProgressColor function
  const getProgressColor = (progress) => {
    if (progress <= 30) {
      return "danger";
    } else if (progress <= 60) {
      return "warning";
    } else {
      return "success";
    }
  };

  // Define handleCloseEditModal, handleCloseCommentModal, handleCloseViewModal functions
  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  const handleCloseCommentModal = () => {
    setShowCommentModal(false);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };

  // Define handleEdit, handleComment, handleView functions
  const handleEdit = (subgoals) => {
    setEditedSubGoal(subgoals);
    setShowEditModal(true);
  };

  const handleComment = (subgoals) => {
    setSelectedSubGoal(subgoals);
    setShowCommentModal(true);
  };

  const handleView = (subgoals) => {
    setViewSubGoal(subgoals); // Set the viewSmartGoal state
    setShowViewModal(true);
  };

  // Define handleSaveEditedSmartGoal function
  const handleSaveEditedSubGoal = () => {
    // Logic to save the edited smart goal
    setShowEditModal(false);
  };

  return (
    <div>
      {/* Your DataTable rendering logic */}
      <ReactBootstrap.Table striped bordered hover size="sm">
        <thead className="text-left">
          <tr className="tableheading">
            <th>#</th>
            <th>Sub Goal</th>
            <th>Description</th>
            <th>Start Date</th>
            <th>End Date</th>
            {/* <th>Designation</th>
                        <th>Assigness</th> */}
            <th>Progress</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((subgoals, index) => (
            <tr className="text-left" key={index}>
              <td>{subgoals.id}</td>
              <td>{subgoals.title}</td>
              <td>{subgoals.description}</td>
              <td>{subgoals.startdate}</td>
              <td>{subgoals.enddate}</td>
              {/* <td>{smartgoal.designationid}</td>
                            <td>{smartgoal.assignees}</td> */}
              <td>
                <ProgressBar
                  variant={getProgressColor(subgoals.progress)}
                  now={subgoals.progress}
                />
              </td>
              {/* Action buttons */}
              <td>
                {/* <ReactBootstrap.Button className='bg-transparent border-0  col-sm-3' onClick={() => handleComment(smartgoal)}><img src={commentbtn} width="20"></img></ReactBootstrap.Button> */}
                <ReactBootstrap.Button
                  className="bg-transparent border-0  col-sm-3"
                  onClick={() => handleView(subgoals)}
                >
                  <img src={viewbtn} width="20"></img>
                </ReactBootstrap.Button>
                <ReactBootstrap.Button
                  className="bg-transparent border-0   col-sm-3"
                  onClick={() => handleEdit(subgoals)}
                >
                  <img src={Editbtn} width="20"></img>
                </ReactBootstrap.Button>
              </td>
            </tr>
          ))}
        </tbody>
      </ReactBootstrap.Table>

      {/* Edit Modal */}
      {showEditModal && editedSubGoal && (
        <ReactBootstrap.Modal
          show={showEditModal}
          onHide={handleCloseEditModal}
        >
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title>
              Edit Sub Goal
            </ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>
            {/* Editable form fields */}
            <div>
              <label>Title:</label>
              <input
                type="text"
                value={editedSubGoal.title}
                onChange={(e) =>
                  setEditedSubGoal({ ...editedSubGoal, title: e.target.value })
                }
              />
            </div>
            <div>
              <label>Description:</label>
              <input
                type="text"
                value={editedSubGoal.description}
                onChange={(e) =>
                  setEditedSubGoal({
                    ...editedSubGoal,
                    description: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>Start Date:</label>
              <input
                type="date"
                value={editedSubGoal.startdate}
                onChange={(e) =>
                  setEditedSubGoal({
                    ...editedSubGoal,
                    startdate: e.target.value,
                  })
                }
              />
            </div>
            {/* Add input fields for other attributes as needed */}
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer>
            <ReactBootstrap.Button
              variant="secondary"
              onClick={handleCloseEditModal}
            >
              Close
            </ReactBootstrap.Button>
            {/* On clicking the Update button, call handleSaveEditedSmartGoal to save changes */}
            <ReactBootstrap.Button
              variant="primary"
              onClick={handleSaveEditedSubGoal}
            >
              Update
            </ReactBootstrap.Button>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>
      )}

      {/* Comment Modal */}
      {/* <ReactBootstrap.Modal show={showCommentModal} onHide={handleCloseCommentModal}>
                Content of the comment modal
            </ReactBootstrap.Modal> */}

      {/* View Modal */}

      <ReactBootstrap.Modal show={showViewModal} onHide={handleCloseViewModal}>
        {/* Content of the view modal */}
        {viewSubGoal && (
          <ReactBootstrap.Modal.Dialog className="w-100">
            <ReactBootstrap.Modal.Header closeButton>
              <ReactBootstrap.Modal.Title>Sub Goal</ReactBootstrap.Modal.Title>
            </ReactBootstrap.Modal.Header>
            <ReactBootstrap.Modal.Body>
              <p>Title: {viewSubGoal.title}</p>
              <p>Description: {viewSubGoal.description}</p>
              <p>Start Date: {viewSubGoal.startdate}</p>
              <p>End Date: {viewSubGoal.enddate}</p>
              <p>Designation: {viewSubGoal.designationid}</p>
              <p>Assignees: {viewSubGoal.assignees}</p>
              <p>Progress: {viewSubGoal.progress}</p>
            </ReactBootstrap.Modal.Body>
            <ReactBootstrap.Modal.Footer>
              <ReactBootstrap.Button
                variant="secondary"
                onClick={handleCloseViewModal}
              >
                Close
              </ReactBootstrap.Button>
              {/* Handle the logic for saving changes here if needed */}
            </ReactBootstrap.Modal.Footer>
          </ReactBootstrap.Modal.Dialog>
        )}
      </ReactBootstrap.Modal>

      {/* Pagination */}
      <ReactBootstrap.Pagination>
        {Array.from(
          { length: Math.ceil(posts.subgoals.length / postsPerPage) },
          (_, index) => (
            <ReactBootstrap.Pagination.Item
              key={index}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </ReactBootstrap.Pagination.Item>
          )
        )}
      </ReactBootstrap.Pagination>
    </div>
  );
};

export default SubData;
